import { LinkedTagListCell } from "../../../../../components/molecules/Table/Cell";

export function getShipmentTransferOrders(order) {
  return order?.transfer_orders;
}

export function ShipmentTransferOrdersCell({ order, width = 100 }) {
  return (
    <LinkedTagListCell
      items={getShipmentTransferOrders(order)}
      getTo={to => `/transfer_order/${to.id}`}
      width={width}
    />
  );
}
